<template>
    <div v-loading="loading" element-loading-text="查询中..." ref="roleList">
        <ul class="switch-list clearfix ml10">
            <el-radio-group v-model="checkedRoleId">
                <div  class="switch-item " v-for="role in comRoleList" style="width: 350px;">
                    <el-radio :label="role.id">
                        <span class="inline-block ellipsis-1"><i class="icon iconfont icon-wujiaoxingman" style="color: #eaea0f;"></i>{{role.comName}} - {{role.name}}</span>
                    </el-radio>
                </div>
            </el-radio-group>
        </ul>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'

    import retailerAuthxApi from '../../api/retailerAuthx'

    export default {
        name: 'swb-role-list-select',
        desc: '岗位列表',
        props: ['comId', 'bizUnitId', 'bizUnitIds'],
        data: function () {
            return {
                loading: false,
                comRoleList: [],
                checkedRoleId: null
            }
        },
        created: function () {
            let bizUnitIds = this.bizUnitIds || [];
            if(bizUnitIds.length > 0) {
                for(let i = 0; i < bizUnitIds.length; i++) {
                    this.getRetailerComRoleList(bizUnitIds[i]);
                }
            } else {
                this.getRetailerComRoleList(this.bizUnitId);
            }
        },
        methods: {
            getRetailerComRoleList: function (bizUnitId) {
                let self = this;
                let postData = {};
                postData.comFlag = true;
                postData.comId = self.comId;
                if(bizUnitId != null) {
                    postData.bizUnitId = bizUnitId;
                }
                retailerAuthxApi.getRetailerComRoleList(postData, function (result) {
                    if(result.type === "info") {
                        let propbizUnitIds = self.bizUnitIds || [];
                        if(propbizUnitIds.length > 0) {
                            let comRoleList = self.comRoleList || [];
                            let roleIds = comRoleList.pluck("id") || [];
                            let dataList = result.data || [];
                            for(let i = 0; i < dataList.length; i++) {
                                let dataInfo = dataList[i];
                                if(!roleIds.contains(dataInfo.id)) {
                                    comRoleList.push(dataInfo);
                                }
                            }
                            self.comRoleList = Utils.merge([], comRoleList);
                        } else {
                            self.comRoleList = Utils.merge([], result.data);
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                result.type = "info";
                let checkedRoleId = self.checkedRoleId;
                let comRoleList = self.comRoleList || [];
                let comRole = comRoleList.find(function (item) {
                    return item.id == checkedRoleId;
                })
                result.data = comRole;
                return result;
            }
        },
    }
</script>





// WEBPACK FOOTER //
// src/compo/authx/ComRoleSelect.vue